import travelAppImage from 'marketing-website/media/images/pages/examples/travel-app@2x.jpg';
import animatedAppImage from 'marketing-website/media/images/pages/examples/animated-app@2x.jpg';
import financeAppImage from 'marketing-website/media/images/pages/examples/finance-app@2x.jpg';
import hotelWebsiteImage from 'marketing-website/media/images/pages/examples/hotel-website@2x.jpg';
import jobsWebsiteImage from 'marketing-website/media/images/pages/examples/jobs-website@2x.jpg';
import doctorAppImage from 'marketing-website/media/images/pages/examples/doctor-app@2x.jpg';

import * as paths from './paths';
import {
  CONTAINERS,
  EMBED,
  TIMER,
  FIXED_HEADER_FOOTER,
  LAYERS,
  GIF,
  TRANSITIONS,
} from './features';

const data = [
  {
    name: 'Healthcare',
    title: 'Healthcare app prototype inspiration',
    description:
      'A prototype with multiple flows and chat simulation for on-demand healthcare.',
    path: paths.DOCTOR_APP,
    previewImage: doctorAppImage,
    prototypeSlug: '6g2c8e0',
    features: [CONTAINERS, LAYERS, TIMER],
    isMobile: true,
    tags: ['Health', 'Chat', 'Mobile'],
  },
  {
    name: 'Chat',
    title: 'Messaging app prototype example',
    description:
      'See how a gamified messaging app can be prototyped before handing off to developers.',
    path: paths.ANIMATED_CHAT_APP,
    previewImage: animatedAppImage,
    prototypeSlug: 'j9750e',
    features: [TIMER, GIF],
    isMobile: true,
    tags: ['Social Media', 'Gif', 'Timers'],
  },
  {
    name: 'Hotel',
    title: 'Hotel booking app prototype example',
    description: 'A prototype for finding and booking holiday accommodation.',
    path: paths.HOTEL_APP,
    previewImage: hotelWebsiteImage,
    prototypeSlug: '13g69h4e',
    features: [EMBED, CONTAINERS, FIXED_HEADER_FOOTER],
    isMobile: false,
    tags: ['Travel', 'Website'],
  },
  {
    name: 'Travel',
    title: 'Travel app prototype inspiration | Marvel',
    description: 'A simple prototype for finding and purchasing holidays.',
    path: paths.TRAVEL_APP,
    previewImage: travelAppImage,
    prototypeSlug: '13g1eh24',
    features: [EMBED, TRANSITIONS, FIXED_HEADER_FOOTER],
    isMobile: true,
    tags: ['Travel', 'Mobile', 'Booking', 'Maps'],
  },

  {
    name: 'Recruitment',
    title: '',
    description: 'An example of a desktop prototype for a recruitment website.',
    path: paths.JOBS_WEBSITE,
    previewImage: jobsWebsiteImage,
    prototypeSlug: '5j3628i',
    features: [EMBED, CONTAINERS, TRANSITIONS],
    isMobile: false,
    tags: ['Recruitment', 'Desktop', 'Containers', 'Embeds'],
  },
  {
    name: 'Finance',
    title: 'Banking app prototype example',
    description:
      'A large mobile banking prototype featuring several flows around.',
    path: paths.FIANCE_APP,
    previewImage: financeAppImage,
    prototypeSlug: '6g00b39',
    features: [EMBED, CONTAINERS, FIXED_HEADER_FOOTER],
    isMobile: true,
    tags: ['Finance', 'Mobile'],
  },
];

export default data;



// WEBPACK FOOTER //
// ./src/configs/pages/examples/data.js